import React, { useState } from "react";
import RefundConfirmationHeader from "./Refund/RefundConfirmationHeader";
import RefundConfirmaionSecondaryHeader from "./Refund/RefundConfirmaionSecondaryHeader";
import RefundConfirmationRequestProgress from "./Refund/RefundConfirmationRequestProgress";
import RefundConfirmationOrderIdContainer from "./Refund/RefundConfirmationOrderIdContainer";
import RefundConfirmationFlightDetails from "./Refund/RefundConfirmationFlightDetails";
import RefundConfirmationPassengers from "./Refund/RefundConfirmationPassengers";
import RefundConfirmationRemarks from "./Refund/RefundConfirmationRemarks";
import TicketManagementConfirmationContact from "./Common/TicketManagementConfirmationContact";
import RefundConfimationPricingSection from "./Refund/RefundConfimationPricingSection";
import TicketManagementConfirmationFareRules from "./Common/TicketManagementConfirmationFareRules";
import RefundConfirmationManageOrder from "./Refund/RefundConfirmationManageOrder";

function TicketManagementFlightRefundConfirmationPage() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState();

  return (
    <div className="w-full flex flex-col items-center bg-background min-h-screen">
      <div className="flex flex-col w-full max-w-7xl items-center pb-10">
        <div
          className={`w-full flex flex-col items-center max-w-7xl gap-4 mt-4 px-3 lg:px-6 py-6 `}
        >
          <RefundConfirmationHeader
            data={data}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
          />
          {loading ? (
            <div className="w-full py-4 flex items-center justify-center">
              <div className="primaryLoader"></div>
            </div>
          ) : (
            <div className="flex flex-col w-full">
              <RefundConfirmaionSecondaryHeader data={data} />
              <RefundConfirmationRequestProgress data={data} />
              {data ? <RefundConfirmationManageOrder data={data} /> : null}
              <div className="flex w-full gap-4 lg:gap-6 flex-col lg:flex-row relative">
                <div className="flex flex-col flex-1">
                  <RefundConfirmationOrderIdContainer data={data} />
                  <div className="w-full flex lg:hidden">
                    <RefundConfimationPricingSection data={data} />
                  </div>
                  <RefundConfirmationFlightDetails data={data} />
                  <TicketManagementConfirmationFareRules data={data} />
                  <RefundConfirmationPassengers data={data} />
                  <TicketManagementConfirmationContact data={data} />
                  <RefundConfirmationRemarks data={data} />
                </div>
                <div className="lg:max-w-[350px] w-full hidden lg:flex">
                  <RefundConfimationPricingSection data={data} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TicketManagementFlightRefundConfirmationPage;
